"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getAdultChildCount = getAdultChildCount;
exports.getRequestAirports = getRequestAirports;
exports.getRequestAirportsFilterQuery = getRequestAirportsFilterQuery;
exports.getRequestPaxList = getRequestPaxList;
exports.getRequestTotalPax = getRequestTotalPax;
exports.getRequestTripTotalDays = getRequestTripTotalDays;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _difference_in_days = _interopRequireDefault(require("date-fns/difference_in_days"));
var _join2 = _interopRequireDefault(require("lodash/join"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _constants = require("../constants");
function getRequestTotalPax(pax) {
  return (pax === null || pax === void 0 ? void 0 : pax.adult) + (pax === null || pax === void 0 ? void 0 : pax.child) + (pax === null || pax === void 0 ? void 0 : pax.infant);
}
function getAdultChildCount(pax) {
  return (pax === null || pax === void 0 ? void 0 : pax.adult) + (pax === null || pax === void 0 ? void 0 : pax.child);
}
function getRequestTripTotalDays(legs) {
  if (legs === void 0) {
    legs = [];
  }
  var from = new Date((0, _get2.default)(legs, '[0].departure'));
  var to = new Date((0, _get2.default)(legs, "[" + (legs.length - 1) + "].departure"));
  return (0, _difference_in_days.default)(to, from);
}
function getRequestAirports(searchRequestLegs) {
  return (0, _uniq2.default)((0, _compact2.default)((0, _map2.default)(searchRequestLegs, function (_ref) {
    var originId = _ref.originId,
      destinationId = _ref.destinationId;
    return [originId, destinationId];
  })));
}
function getRequestAirportsFilterQuery(requestAirports) {
  var requestRoutes = (0, _map2.default)(requestAirports, function (legAirports) {
    return (0, _join2.default)(legAirports, _constants.FILTER_PARAM_AIRPORT_SEPARATOR);
  });
  return (0, _join2.default)(requestRoutes, _constants.FILTER_PARAM_LEG_SEPARATOR);
}
function getRequestPaxList(pax) {
  var paxList = [];
  if (pax[_constants.TRAVELLERS_TYPES_MAP.ADULT.label] > 0) paxList.push(_constants.TRAVELLERS_TYPES_MAP.ADULT.code);
  if (pax[_constants.TRAVELLERS_TYPES_MAP.CHILD.label] > 0) paxList.push(_constants.FARE_RULES_PAX_CODE.CHILD);
  if (pax[_constants.TRAVELLERS_TYPES_MAP.INFANT.label] > 0) paxList.push(_constants.TRAVELLERS_TYPES_MAP.INFANT.code);
  return paxList;
}